export default __webpack_public_path__ + "img/ai.df942d46.svg";